module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "FamilyStudentsModal"
  }, [_c('btn', {
    staticStyle: {
      "border-left": "solid 1px #ccc",
      "border-right": "solid 1px #ccc"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getData($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _vm._v("生徒の追加")]), _vm._v(" "), _c('component-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.condition.condition),
      expression: "condition.condition"
    }],
    attrs: {
      "transition": "expand"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("生徒登録")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('table', {
    staticClass: "m-table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("名前")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.f_name),
      expression: "student.f_name"
    }],
    staticClass: "half",
    attrs: {
      "type": "text",
      "placeholder": "姓"
    },
    domProps: {
      "value": (_vm.student.f_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "f_name", $event.target.value)
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.l_name),
      expression: "student.l_name"
    }],
    staticClass: "half",
    attrs: {
      "type": "text",
      "placeholder": "名"
    },
    domProps: {
      "value": (_vm.student.l_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "l_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("かな")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.f_name_kana),
      expression: "student.f_name_kana"
    }],
    staticClass: "half",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "せい"
    },
    domProps: {
      "value": (_vm.student.f_name_kana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "f_name_kana", $event.target.value)
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.l_name_kana),
      expression: "student.l_name_kana"
    }],
    staticClass: "half",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "めい"
    },
    domProps: {
      "value": (_vm.student.l_name_kana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "l_name_kana", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("性別")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.gender,
      "label": "name",
      "show-labels": false,
      "placeholder": "性別"
    },
    on: {
      "select": _vm.select
    },
    model: {
      value: (_vm.watch.gender),
      callback: function($$v) {
        _vm.$set(_vm.watch, "gender", $$v)
      },
      expression: "watch.gender"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("生年月日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.birthday),
      expression: "student.birthday"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "生年月日"
    },
    domProps: {
      "value": (_vm.student.birthday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "birthday", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("年齢")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.calcAge))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("公/国/私")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.school_type,
      "label": "name",
      "show-labels": false,
      "placeholder": "公/国/私"
    },
    on: {
      "select": _vm.select
    },
    model: {
      value: (_vm.watch.school_type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "school_type", $$v)
      },
      expression: "watch.school_type"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("留年・浪人" + _vm._s(_vm.student.grade_flag))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.grade_flag),
      expression: "student.grade_flag"
    }],
    attrs: {
      "type": "number",
      "placeholder": "留年・浪人"
    },
    domProps: {
      "value": (_vm.student.grade_flag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "grade_flag", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学年")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.calcGrade))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学校名")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.school_name),
      expression: "student.school_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "学校名"
    },
    domProps: {
      "value": (_vm.student.school_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "school_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("指導詳細")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.guidance_detail),
      expression: "student.guidance_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "指導詳細"
    },
    domProps: {
      "value": (_vm.student.guidance_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "guidance_detail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("次回引継時期")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.takeover_time),
      expression: "student.takeover_time"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "次回引継時期"
    },
    domProps: {
      "value": (_vm.student.takeover_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "takeover_time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("優先度")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.priority,
      "label": "name",
      "show-labels": false,
      "placeholder": "優先度"
    },
    on: {
      "select": _vm.select
    },
    model: {
      value: (_vm.watch.priority),
      callback: function($$v) {
        _vm.$set(_vm.watch, "priority", $$v)
      },
      expression: "watch.priority"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("役務開始")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.service_period_start),
      expression: "student.service_period_start"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "役務開始"
    },
    domProps: {
      "value": (_vm.student.service_period_start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "service_period_start", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("役務終了")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.service_period_end),
      expression: "student.service_period_end"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "役務終了"
    },
    domProps: {
      "value": (_vm.student.service_period_end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "service_period_end", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.note),
      expression: "student.note"
    }],
    attrs: {
      "placeholder": "備考"
    },
    domProps: {
      "value": (_vm.student.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "note", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.postStudentModal($event)
      }
    }
  }, [_vm._v("登録")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.showModal($event)
      }
    }
  }, [_vm._v("キャンセル")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca0936ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Family/FamilyStudentsModal.vue
// module id = 1457
// module chunks = 0